import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="task"
export default class extends Controller {
  static targets = [ 'link' ]

  connect() {
  }

  show(event) {
    const isLink = event.target.tagName === 'A';
    const wrapper = event.target.closest('.task_wrapper')
    const isFloatMenu = event.target.closest('div[data-controller="float-menu"]');
    if (isLink || isFloatMenu) {
      return;
    }

    event.preventDefault()
    this.linkTarget.click()

    if (wrapper.classList.contains('focus')) {
      return;
    }
    wrapper.classList.add('focus')
    // 非同期にしないと「表示直後のクリックイベント」が拾われてしまう
    setTimeout(() => {
      this.setDeactivate()
    }, 100);
  }

  setDeactivate() {
    const self = this;
    document.addEventListener('click', deactivate);
    function deactivate(event) {
      const isFloatMenu = event.target.closest('div[data-float-menu-target="menu"]');
      const isSidePage = event.target.closest('div[data-controller="side-page"]');
      const isSelf = event.target.closest('.task_handler') === self.element;
      if (!isFloatMenu && !isSidePage && !isSelf) {
        document.removeEventListener('click', deactivate);
        self.element.classList.remove('focus')
      }
    }
  }
}
